export const DRAGGABLE_TYPES = { SECTION: "section", ITEM: "item" };

export const MEASURING_CONFIG = { droppable: { frequency: 500 } };

export const POINTER_SENSOR_CONFIG = { activationConstraint: { distance: 8 } };

export const TOUCH_SENSOR_CONFIG = {
  activationConstraint: { delay: 300, tolerance: 5 },
};
